import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/call-center'),
      component: Index,
      props: {},
      children: [
        {
          path: '',
          name: 'voice_agent_wrapper',
          meta: {
            permissions: ['administrator'],
          },
          redirect: to => {
            return { name: 'voice_agent_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'voice_agent_list',
          meta: {
            permissions: ['administrator'],
          },
          component: Index,
        },
      ],
    },
  ],
};
